import { combineReducers } from 'redux';
import map from 'ramda/src/map';
import byId from './reducers/byId';
import categories from './categories/reducer';

import {
  IMPORT_SERVICES,
  ADD_SERVICE,
  DELETE_SERVICE,
  UPDATE_SERVICE_ORDER,
} from './constants';

function listReducer(state = [], action) {
  switch (action.type) {
    case IMPORT_SERVICES:
      return action.response.result;
    case ADD_SERVICE:
      return [...state, action.response.result];
    case DELETE_SERVICE:
      return state.filter(id => id !== action.serviceId);
    case UPDATE_SERVICE_ORDER:
      return map(service => service.id)(action.services);
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  list: listReducer,
  categories,
});
